module.exports = __webpack_public_path__ + "static/banner-e1c2d4b47e33ff74a7a141685c413b40.png";